module.exports = __webpack_public_path__ + "img/newpath.0a07067a.png";